// extracted by mini-css-extract-plugin
var _1 = "pvIXt";
var _2 = "kbJlv";
var _3 = "ceDav";
var _4 = "fLLog";
var _5 = "bPPfv";
var _6 = "T9YvI";
var _7 = "h2r3x";
var _8 = "zMXgf";
var _9 = "CAFSQ";
export { _1 as "base", _2 as "facets", _3 as "inspector", _4 as "main", _5 as "nav", _6 as "results", _7 as "search", _8 as "splitPane", _9 as "truncatedMessage" }
